import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phone = "919720009997";
  const message = encodeURIComponent("Hi BananaX concierge — I'd like assistance.");
  return (
    <a
      href={`https://wa.me/${phone}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="WhatsApp support"
      data-testid="whatsapp-support-btn"
    >
      <div className="absolute inset-0 rounded-full bg-gold/30 blur-xl group-hover:bg-gold/50 transition-all"></div>
      <div className="relative w-14 h-14 rounded-full bg-ink-900 border border-gold/40 flex items-center justify-center hover:border-gold transition-all">
        <MessageCircle className="w-5 h-5 text-gold stroke-[1.4]" />
      </div>
    </a>
  );
}
